import './App.css';
import { Routes, Route } from 'react-router-dom';
import Login from "./Components/Login";
import Register from "./Components/Register";
import NoOrg from "./Components/NoOrg";
import ForgotPassword from "./Components/ForgotPassword";
import ResetPassword from "./Components/ResetPassword";
import InstancePage from "./Components/InstancePage";

function CenteredPage({ children }) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100dvh',
            backgroundColor: '#F8F9FA',
        }}>
            {children}
        </div>
    );
}

function App() {
    return (
        <Routes>
            <Route path="/register" element={<CenteredPage><Register /></CenteredPage>} />
            <Route path="/no-org" element={<CenteredPage><NoOrg /></CenteredPage>} />
            <Route path="/forgot-password" element={<CenteredPage><ForgotPassword /></CenteredPage>} />
            <Route path="/reset-password" element={<CenteredPage><ResetPassword /></CenteredPage>} />
            <Route path="/:instanceName" element={<InstancePage />} />
            <Route path="/*" element={<CenteredPage><Login /></CenteredPage>} />
        </Routes>
    );
}

export default App;
